<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <h5 class="card-title">
                {{ $t('pages.account.info.title') }}
            </h5>
            <account-data-view-edit></account-data-view-edit>
        </div>
    </div>
</template>

<script>
import AccountDataViewEdit from "../Includes/AccountDataViewEdit";
export default {
name: "AccountInfo",
    components: {AccountDataViewEdit}
}
</script>

<style scoped>

</style>
